<template>
  <section>
    <div class="container mt-0 text-white">
      <div class="row mx-md-auto col-md-8 py-5">
        <div class="col-12 my-5">
          <div class="text-center">
            <img class="col-6" src="@/assets/img/headphones.png" data-aos="fade-up" data-aos-delay="500">
          </div>
          <h2 class="mb-5 text-center" data-aos="fade-up" data-aos-delay="500">Musik nach Ihrem Geschmack</h2>
          <p data-aos="fade-up" data-aos-delay="500">Ich biete Ihnen eine niveauvolle musikalische Begleitung Ihrer Veranstaltung mit den Hits der letzten Jahrzehnte und den besten aktuellen Songs.</p>
          <p data-aos="fade-up" data-aos-delay="500">Meine Musiksammlung wird ständig mit Top-Musikauswahl aktualisiert, um Euch und Euren Gästen die neuesten Titel präsentieren zu können.</p>
          <p data-aos="fade-up" data-aos-delay="500">Ob aktuelle Top100 Charts, 70er, 80er, 90er, 2000er, 2010er Jahre, Disco, NDW, Oldies, Rock & Pop, Apres Ski/Ballermann, Party/Schlager/Fox. Sie sagen, was Sie und Ihre Gäste hören möchten ich spiele ein individuell auf Ihre Wünsche zugeschnittenes Musikprogramm ab. Gerne können wir in einem persönlichen Gespräch und meinem Musikwunschbogen festlegen, welche Musikrichtungen vorzugsweise auf Eurer Feier gespielt werden sollen. </p>
          <p data-aos="fade-up" data-aos-delay="500">Als erfahrener DJ achte ich darauf, dass der richtige Song zum richtigen Zeitpunkt gespielt wird.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

</script>

<style scoped>
section {
  background-image: url('@/assets/img/bgpeople.jpg');
  background-size: cover;
  background-position: bottom;
  background-attachment: fixed;
}
</style>